export default __webpack_public_path__ + "static/media/64t.84050ff1.jpg";